export const upcomingEvents = (params: { ordering: string }) => `upcomingEvents:${params?.ordering}`;
export const searchEvents = (params: { search: string }) => `searchEvents:${params?.search}`;
export const contextualEvents = (params: { context: string; market_slug: string }) =>
  `contextualEvents:${params?.context}:${params?.market_slug}`;
export const pastEvents = 'pastEvents';

export const userFavoriteUpcomingEvents = 'userFavoriteUpcomingEvents';
export const userFavoritePastEvents = 'userFavoritePastEvents';
